import type { ReactNode } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import InfoBox from 'ui/components/ModuleHeader/InfoBox'
import { TimeSeriesTableHelpDialog } from './TimeSeriesTableHelpDialog'
import { TimeSeriesTableHelpTabId } from './timeSeriesTableHelp.helper'

type TimeSeriesTableHelpButtonProps = {
  availableTabIds: TimeSeriesTableHelpTabId[]
  hasSelectionCheckboxes: boolean
}

export function TimeSeriesTableHelpButton({
  availableTabIds,
  hasSelectionCheckboxes,
}: TimeSeriesTableHelpButtonProps): ReactNode {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <div className="shrink-0 whitespace-nowrap">
      <InfoBox
        onInfoButtonClick={() => setOpen(true)}
        wantToLearnMoreText={t('Time series table features - tips and tricks')}
      />
      <TimeSeriesTableHelpDialog
        open={open}
        onClose={() => setOpen(false)}
        availableTabIds={availableTabIds}
        hasSelectionCheckboxes={hasSelectionCheckboxes}
      />
    </div>
  )
}
